const getEmailBody = (record) => {
    const defaultBody = `PLC Risk Analysis Alert

A ${record.risk_level || 'Unknown'} risk anomaly has been detected in the PLC code analysis.

Analysis Details:
----------------- 
Program: ${record.Program || 'N/A'}
Routine: ${record.Routine || 'N/A'}
Rung: ${record.Rung || 'N/A'}
Code: ${record.Code || 'N/A'}
Anomaly Type: ${record.anomaly_type || 'N/A'}
Risk Level: ${record.risk_level || 'N/A'}

Explanation:
${record.explanation || 'No explanation provided'}

Suggested Solution:
${record.solution || 'No solution provided'}

Assignment Details:
-------------------
Assigned To: ${record.assignTo || 'Unassigned'}
Due Date: ${record.dueDate || 'Not set'}
Status: ${record.status || 'Pending'}
Comments: ${record.comments || 'No comments'}

Please review this issue and take appropriate action.

This is an automated alert from the PLC Risk Analyzer system.`;

  return defaultBody;
}

const statusOptions = ['Pending', 'Reviewing', 'Resolved', 'Ignored'];

const getEmailSubject = (record) => {
  return `PLC Risk Alert - ${record.risk_level || 'Unknown'} Risk Detected`;
}

const riskLevels = [
    { key: 'High', label: 'High Risk', color: 'danger' },
    { key: 'Medium', label: 'Medium Risk', color: 'warning' },
    { key: 'Low', label: 'Low Risk', color: 'success' }
  ];
export { getEmailBody, statusOptions, getEmailSubject, riskLevels };